<script setup lang="ts">

defineOptions({
  name: 'Example'
});

const showBack = ref(false);

</script>
<template>
  <div class="app relative-position">
    <transition name="flip">
      <div v-if="showBack" class="card back">
        <!-- 卡片背面内容 -->
        背面内容
      </div>
      <div v-else class="card front">
        <!-- 卡片正面内容 -->
        正面内容
      </div>
    </transition>
    <button class="absolute-bottom" @click="showBack = !showBack">翻转卡片</button>
  </div>
</template>

<style scoped>
.app {
  width: 300px;
  height: 300px;
}
.card {
  width: 200px;
  height: 260px;
  border: red 1px solid;
  perspective: 100px;
}

.flip-enter-active, .flip-leave-active {
  transition: transform 0.8s;
  backface-visibility: hidden;
}

.flip-enter, .flip-leave-to /* .flip-leave-active for <2.1.8 */ {
  transform: rotateY(180deg);
}

.front, .back {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
}

.back {
  transform: rotateY(180deg);
}
</style>